define('services/jsonconverter',["require", "exports"], function (require, exports) {
    "use strict";
    var JsonConverter = (function () {
        function JsonConverter() {
        }
        JsonConverter.prototype.convertPropertyNamesToCamelCase = function (item) {
            var _this = this;
            if (item == null)
                return item;
            if (item instanceof Array) {
                item.forEach(function (i) {
                    _this.convertPropertyNamesToCamelCase(i);
                });
                return item;
            }
            if (typeof item != "object")
                return item;
            var properties = Object.getOwnPropertyNames(item);
            properties.forEach(function (property) {
                var firstSign = property.substring(0, 1).toLowerCase();
                var propertyName = firstSign + property.substring(1, property.length);
                if (propertyName != property) {
                    var value = item[property];
                    if (value != null && typeof value == "object") {
                        value = _this.convertPropertyNamesToCamelCase(value);
                    }
                    Object.defineProperty(item, propertyName, {
                        configurable: true,
                        enumerable: true,
                        get: function () { return value; },
                        set: function (data) { value = data; }
                    });
                    // remove old property
                    delete item[property];
                }
            });
            return item;
        };
        JsonConverter.prototype.convertPropertyNamesToPascalCase = function (item) {
            var _this = this;
            if (item == null)
                return item;
            if (item instanceof Array) {
                item.forEach(function (i) {
                    _this.convertPropertyNamesToPascalCase(i);
                });
                return item;
            }
            if (typeof item != "object")
                return item;
            var properties = Object.getOwnPropertyNames(item);
            properties.forEach(function (property) {
                var firstSign = property.substring(0, 1).toUpperCase();
                var propertyName = firstSign + property.substring(1, property.length);
                if (propertyName != property) {
                    var value = item[property];
                    if (value != null && typeof value == "object") {
                        value = _this.convertPropertyNamesToPascalCase(value);
                    }
                    Object.defineProperty(item, propertyName, {
                        configurable: true,
                        enumerable: true,
                        get: function () { return value; },
                        set: function (data) { value = data; }
                    });
                    // remove old property
                    delete item[property];
                }
            });
            return item;
        };
        // extends 'from' object with members from 'to'. If 'to' is null, a deep clone of 'from' is returned
        JsonConverter.prototype.extend = function (from, to) {
            if (from == null || typeof from != "object")
                return from;
            // if (from.constructor != Object && from.constructor != Array) return from;
            if (from.constructor == Date || from.constructor == RegExp || from.constructor == Function ||
                from.constructor == String || from.constructor == Number || from.constructor == Boolean)
                return new from.constructor(from);
            if (from._isAMomentObject != null) {
                return moment(from);
            }
            to = to || new from.constructor();
            for (var name in from) {
                to[name] = typeof to[name] == "undefined" ? this.extend(from[name], null) : from[name];
            }
            return to;
        };
        return JsonConverter;
    }());
    return JsonConverter;
});

